import formatedLocalStorage from '@/utils/formatedLocalStorage';

export default {
  CLIENTS: (state) => state.clients,
  CLIENT: (state) => (!state.client ? formatedLocalStorage('client') : state.client),
  MESSAGES: (state) => state.messages,
};
